import { Controller } from "@hotwired/stimulus"

// Lista de filas numeradas donde el orden en el DOM es el dato: el servidor
// asigna la posición según el índice del arreglo que recibe. La usa el armado
// de una unidad ("clase 1", "clase 2", …).
export default class extends Controller {
  static targets = ["container", "template", "item", "position", "empty"]

  add(event) {
    event?.preventDefault()

    // NEW_INDEX evita que dos filas nuevas compartan id de combobox.
    const html = this.templateTarget.innerHTML.replaceAll("NEW_INDEX", crypto.randomUUID().slice(0, 8))
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    this.#refresh()
    this.containerTarget.lastElementChild?.querySelector("input[type=text]")?.focus()
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-ordered-list-target='item']")?.remove()
    this.#refresh()
  }

  moveUp(event) {
    event.preventDefault()
    const item = event.target.closest("[data-ordered-list-target='item']")
    item?.previousElementSibling?.before(item)
    this.#refresh()
  }

  moveDown(event) {
    event.preventDefault()
    const item = event.target.closest("[data-ordered-list-target='item']")
    const next = item?.nextElementSibling
    if (next) next.after(item)
    this.#refresh()
  }

  // Renumera las etiquetas y muestra u oculta el aviso de lista vacía. Emite
  // "ordered-list:cambio": el orden es un dato (lo escucha el autoguardado).
  #refresh() {
    this.positionTargets.forEach((label, index) => { label.textContent = index + 1 })
    this.emptyTarget?.classList.toggle("hidden", this.itemTargets.length > 0)
    this.dispatch("cambio")
  }
}
